<form [formGroup]="myForm" (ngSubmit)="onSubmit()">
  <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 35vh)' }">
    <div
      class="wp-form-container radius-8 border-20 p-b-0"
      style="padding: 15px"
    >
      <div class="wp-form m-b-20">
        <div class="row">
          <div class="col-md-6">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Name <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('name')?.invalid && myForm.get('name')?.touched
                  "
                  class="error-message"
                >
                  Name is required.
                </div>
              </div>
              <input
                type="text"
                formControlName="name"
                placeholder="Enter name"
                class="b3 text-90"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Business Theme <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('theme_id')?.invalid &&
                    myForm.get('theme_id')?.touched
                  "
                  class="error-message"
                >
                  Business Theme is required.
                </div>
              </div>
              <p-dropdown
                formControlName="theme_id"
                class="b3 text-90"
                [options]="businessThemeLists"
                optionValue="theme_id"
                optionLabel="value"
                placeholder="Select"
                [overlayOptions]="helper.getOverlayOptions()"
              />
            </div>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-6">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Area Of Impact <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('area_of_impact')?.invalid &&
                    myForm.get('area_of_impact')?.touched
                  "
                  class="error-message"
                >
                  Area of Impact is required.
                </div>
              </div>
              <p-dropdown
                formControlName="area_of_impact"
                class="b3 text-90"
                optionLabel="label"
                optionValue="key"
                [options]="areaImpactOption"
                placeholder="Select"
                [overlayOptions]="helper.getOverlayOptions()"
              />
            </div>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-4">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Brand <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('brand')?.invalid && myForm.get('brand')?.touched
                  "
                  class="error-message"
                >
                  Brand is required.
                </div>
              </div>
              <p-dropdown
                formControlName="brand"
                [options]="brandLists"
                class="b3 text-90"
                optionLabel="brand"
                optionValue="brand_id"
                placeholder="Select"
                (onChange)="onBrandChange($event)"
                [overlayOptions]="helper.getOverlayOptions()"
              ></p-dropdown>
            </div>
          </div>
          <div class="col-md-4">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Therapeutic Area <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('therapeutic_area')?.invalid &&
                    myForm.get('therapeutic_area')?.touched
                  "
                  class="error-message"
                >
                  Therapeutic Area is required.
                </div>
              </div>
              <p-dropdown
                formControlName="therapeutic_area"
                class="b3 text-90"
                [options]="therapeuticLists"
                optionLabel="area"
                optionValue="therapeutic_area_id"
                placeholder="Select"
                (onChange)="onTherapeuticAreaChange($event)"
                [overlayOptions]="helper.getOverlayOptions()"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="dis-flex flex-col">
              <div class="flex">
                <label class="b3 text-90">Indication <span class="mandatory">*</span></label>
                <div
                  *ngIf="
                    myForm.get('indication')?.invalid &&
                    myForm.get('indication')?.touched
                  "
                  class="error-message"
                >
                   Indication is required.
                </div>
              </div>
              <p-dropdown
                formControlName="indication"
                class="b3 text-90"
                optionValue="indication_id"
                [options]="indicationsLists"
                optionLabel="indication"
                placeholder="Select"
                [overlayOptions]="helper.getOverlayOptions()"
              />
            </div>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-12">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Description <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('description')?.invalid &&
                    myForm.get('description')?.touched
                  "
                  class="error-message"
                >
                  Description is required.
                </div>
              </div>
              <textarea
                formControlName="description"
                class="b3 text-90"
                rows="5"
                cols="30"
                placeholder="Enter description here"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-12">
            <!-- <p-toast /> -->
            <p-fileUpload
              name="file"
              chooseLabel="Browse"
              [url]="uploadUrl"
              (onUpload)="onUpload($any($event))"
              accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
              [maxFileSize]="104857600"
              [auto]="true"
              [withCredentials]="true"
            >
              <ng-template pTemplate="content">
                <ul *ngIf="uploadedFiles.length">
                  <li
                    *ngFor="let file of uploadedFiles"
                    class="dis-flex flex-m"
                  >
                    <div [ngbTooltip]="file?.name">
                      {{ file?.name | truncate:15 }}
                    </div>
                    <button
                      class="icon-btn text-delete dis-flex"
                      (click)="removeFile(file?.file_id)"
                      ngbTooltip="Remove File"
                    >
                      <ng-icon name="hugeDelete02"></ng-icon>
                    </button>
                  </li>
                </ul>
              </ng-template>
            </p-fileUpload>
          </div>
        </div>
      </div>

      <div class="team-members-container m-b-20">
        <div class="row">
          <div class="dis-flex flex-col m-r-20">
           <div class="d-flex">
            <label class="b3 text-90"
            >Members <span class="mandatory">*</span></label
          ><div
          *ngIf="
            myForm.get('members')?.invalid &&
            myForm.get('members')?.touched
          "
          class="error-message"
        >
        Members is required.
        </div>
           </div>
            <p-multiSelect
              class="b3 text-90 wp-members-dropdown"
              [options]="teamMembersLists"
              formControlName="members"
              optionLabel="name"
              [showToggleAll]="false"
              [displaySelectedLabel]="false"
              display="chip"
              filter="true"
              [placeholder]="'Select Members'"
              (onFilter)="onMemberSearchChange($event)"
              (onChange)="onMembersChange($event)"
              [overlayOptions]="helper.getOverlayOptions()"
            >
              <!-- Custom template for selected items -->
              <ng-template pTemplate="selectedItems" let-selectedItems>
                <ng-container
                  *ngIf="selectedItems?.length <= 3; else moreSelected "
                >
                  <span
                    *ngFor="let item of selectedItems;let i = index"
                    class="selected-chip"
                  >
                    {{ item.name }}
                    <!-- <button
                      type="button"
                      class="remove-button m-l-5 fs-13 radius-22"
                      (click)="removeMember(i)"
                    >
                      ✖
                    </button> -->
                  </span>
                </ng-container>
                <ng-template #moreSelected>
                  <span
                    *ngFor="let item of selectedItems?.slice(0, 3);let i = index"
                    class="selected-chip"
                  >
                    {{ item.name }}
                    <!-- <button
                      type="button"
                      class="remove-button m-l-5 fs-13 radius-22"
                      (click)="removeMember(i)"
                    >
                      ✖
                    </button> -->
                  </span>
                  <span class="more-count"
                    >+{{ selectedItems?.length - 3 }}</span
                  >
                </ng-template>
              </ng-template>
            </p-multiSelect>
          </div>

          <!-- Owner Section -->
          <div class="dis-flex flex-col">
            <label class="caption text-60">Owner</label>
            <div class="wp-owner-data">
              <img
                src="{{ env.assetUrl }}/user_placeholder.jpg"
                alt="{{ env.assetUrl }}/user_placeholder.png"
              />
              <div>
                <span class="b3 text-10">{{ userData?.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="selectedMemberNames.length > 0">
          <label class="caption text-60">Members</label>
          <div class="wp-members-data dis-flex flex-w">
            <div *ngFor="let member of selectedMemberNames; let i = index">
              <img
                [src]="
                  member?.detail?.avatar ||
                  member?.avatar ||
                  env.assetUrl + '/user_placeholder.png'
                "
              />
              <div class="p-r-0">
                <span class="b3 text-10">{{
                  member?.detail?.name || member?.name
                }}</span>
                <button
                  type="button"
                  class="remove-button m-l-5 fs-13 radius-22"
                  (click)="removeMember(i)"
                  aria-label="Remove Member"
                >
                  ✖
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p-divider class="horizontal-divider" />
      <div class="wp-document-data m-t-20" #previewContent>
        <div class="row">
          <div class="col-md-10">
            <h4 class="font-medium">Document Related Data Points</h4>
          </div>
          <div class="col-md-2">
            <button
              class="btn outline primary"
              type="button"
              (click)="previewPDF($event)"
            >
              <ng-icon class="lh-1-0 m-r-5" name="hugeView"></ng-icon>Preview
            </button>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-12">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Background / Context <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('document_context')?.invalid &&
                    myForm.get('document_context')?.touched
                  "
                  class="error-message"
                >
                  Background is required.
                </div>
              </div>
              <textarea
                formControlName="document_context"
                class="b3 text-90"
                rows="5"
                cols="30"
                placeholder="Enter the background / context here"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-12">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Desired Outcome <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('document_outcome')?.invalid &&
                    myForm.get('document_outcome')?.touched
                  "
                  class="error-message"
                >
                  Desired Outcome is required.
                </div>
              </div>
              <textarea
                formControlName="document_outcome"
                class="b3 text-90"
                rows="5"
                cols="30"
                placeholder="Enter the desired outcome here"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-12">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Capabilities & Experience Required
                  <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('document_capabilities')?.invalid &&
                    myForm.get('document_capabilities')?.touched
                  "
                  class="error-message"
                >
                  Capabilities are required.
                </div>
              </div>
              <p-editor
                formControlName="document_capabilities"
                [style]="{ height: '100px' }"
              />
            </div>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-6">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Key Milestone <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('document_milestones')?.invalid &&
                    myForm.get('document_milestones')?.touched
                  "
                  class="error-message"
                >
                  Key Milestone is required.
                </div>
              </div>
              <textarea
                formControlName="document_milestones"
                class="b3 text-90"
                rows="5"
                cols="30"
                placeholder="Enter key milestones here"
              ></textarea>
            </div>
          </div>
          <div class="col-md-6">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Resources Needed <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('document_resources')?.invalid &&
                    myForm.get('document_resources')?.touched
                  "
                  class="error-message"
                >
                  Resources Needed are required.
                </div>
              </div>
              <textarea
                formControlName="document_resources"
                class="b3 text-90"
                rows="5"
                cols="30"
                placeholder="Enter the resources needed here"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-4">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Tools <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('document_tools')?.invalid &&
                    myForm.get('document_tools')?.touched
                  "
                  class="error-message"
                >
                  Tools are required.
                </div>
              </div>
              <textarea
                formControlName="document_tools"
                class="b3 text-90"
                rows="5"
                cols="30"
                placeholder="Enter tools here"
              ></textarea>
            </div>
          </div>
          <div class="col-md-4">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Timeframe <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('document_timeframe')?.invalid &&
                    myForm.get('document_timeframe')?.touched
                  "
                  class="error-message"
                >
                  Timeframe is required.
                </div>
              </div>
              <textarea
                formControlName="document_timeframe"
                class="b3 text-90"
                rows="5"
                cols="30"
                placeholder="Enter the timeframe here"
              ></textarea>
            </div>
          </div>
          <div class="col-md-4">
            <div class="dis-flex flex-col">
              <div class="d-flex">
                <label class="b3 text-90"
                  >Investment <span class="mandatory">*</span></label
                >
                <div
                  *ngIf="
                    myForm.get('document_investments')?.invalid &&
                    myForm.get('document_investments')?.touched
                  "
                  class="error-message"
                >
                  Investment is required.
                </div>
              </div>
              <textarea
                formControlName="document_investments"
                class="b3 text-90"
                rows="5"
                cols="30"
                placeholder="Enter the investment here"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row m-t-10">
          <div class="col-md-12">
            <p class="b3 text-80 m-b-0">
              * <a href="#">Click here </a>to add a gig to the Opportunity
              MarketPlace in-line with resource fluidity principle.
            </p>
          </div>
        </div>
      </div>
    </div>
  </p-scrollPanel>

  <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
    <button
      class="btn outline wd-100px m-r-10"
      type="button"
      (click)="onClose()"
    >
      Cancel
    </button>
    <button class="btn primary wd-100px" (submit)="onSubmit()">
      {{ !isEditMode ? "Done" : "Update" }}
    </button>
  </div>
</form>
<app-doc-template
class=""
  *ngIf="tempateData"
  [tempateData]="tempateData"
  [userData]="userData"
  (pdfGenerated)="onPDFGenerated()"
></app-doc-template>
